import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

import { Form, FormField } from '@/Core/UI/Form'
import { CostCurrencyField } from '@/Ship/Components/CostCurrencyField'
import { FieldCell, FieldGrid } from '@/Ship/Components/EntityCard'

import { LoadCurrencyTask } from '../Tasks/LoadCurrencyTask'

import type { ApplicationFormContextLike } from '../Contracts/IApplication'

/** Валюта оплати за замовчуванням (легасі `ApplicationPaymentResource.js:30-35`). */
const PAYMENT_DEFAULT_CURRENCY = 'EUR'

interface Props {
    formContext: ApplicationFormContextLike | undefined
}

/** EUR у новій оплаті — лише в порожнє поле й без позначки «змінено». */
const PaymentCreateDefaults = ({ formContext }: { formContext: ApplicationFormContextLike }) => {
    useEffect(() => {
        void LoadCurrencyTask(PAYMENT_DEFAULT_CURRENCY).then((currency) => {
            const current = formContext.values?.['sumCurrency']

            if (currency && (current === undefined || current === null || current === '')) {
                formContext.setInitialValue?.('sumCurrency', currency)
            }
        })
    }, [formContext])

    return null
}

/**
 * Картка оплати заявки (`SPEC-021` §8.7; легасі `ApplicationPaymentFormTemplate.jsx:5-12`):
 * «Дата оплати», «Сума оплати» з валютою одним полем, «Сума транзакції в
 * базовій валюті» (рахує бек за курсом НБУ на дату оплати) і «Коментар».
 */
export const ApplicationPaymentFormTemplate = observer(({ formContext }: Props) => {
    const uuid = formContext?.values?.uuid
    const isNew = typeof uuid !== 'string' || uuid === ''

    if (!formContext) return null

    return (
        <Form formContext={formContext}>
            {isNew ? <PaymentCreateDefaults formContext={formContext} /> : null}
            <FieldGrid>
                <FieldCell wide>
                    <FormField name="date" />
                </FieldCell>
                <FieldCell wide>
                    <CostCurrencyField formContext={formContext} amount="sum" currency="sumCurrency" label="Сума оплати" isRequired />
                </FieldCell>
                {isNew ? null : (
                    <FieldCell wide>
                        <FormField name="sumBaseCurrency" />
                    </FieldCell>
                )}
                <FieldCell wide>
                    <FormField name="comment" />
                </FieldCell>
            </FieldGrid>
        </Form>
    )
})
